import React, { Component } from 'react'

export default class RoomDescription extends Component {
  render () {
    const { room } = this.props

    if (room) {
      return (
        <div className="room_description">
          {room.image && (
            <div className="image_place">
              <img src={room.image.xsmallSquare} />
            </div>
          )}
          <div className="description_place">{room.description}</div>
        </div>
      )
    }

    return null
  }
}
